import React, { useContext, useEffect } from "react";
import { AppContext } from "../../../App";
import { useAllTransactionsDiva } from "../AllTransactionsDiva/hooks/useAllTransactionsDiva";
import { getTheme } from "../../../constants/getTheme";
import { operations } from "../../../util/operationsForFilters";
import { TemplateWrapped } from "../../Layout";
import { ConnectionsMainContent } from "../ConnectionsDiva/components";
import {
  InsuranceVerificationsTable,
  SelectPracticePopover,
  SelectStatusPopover,
} from "../AllTransactionsDiva/components";
import CustomModal from "../../CustomModal";
import FilesList from "../AllTransactions/components/FilesList";
import ConfirmExportExcel from "../AllTransactions/components/confirm-export-excel/ConfirmExportExcel";
import { FiltersExceptions } from "./components/filters-exceptions";
import { useExceptions } from "./hook/useExceptions";

const Exceptions = ({ permissions }) => {
  const appData = useContext(AppContext);
  const selectedPractices = appData.get("selectedPractices") || [];
  const {
    currentDate,
    changeCurrentDate,
    practiceSelectedLabel,
    clientSelected,
    practiceSelected,
    statusSelected,
    practicesListWithName,
    changePracticeSelected,
    popoverState,
    open,
    handleClick,
    handleClose,
    isPracticesOpen,
    isStatusOpen,
    changeStatusSelected,
    togglePracticeModal,
    searchQuery,
    setSearchQuery,
    practicesSelected,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    totalItems,
    transactions,
    handleChangeShowFilesModal,
    handleVerify,
    files,
    setFiles,
    setShowFileModal,
    showFileModal,
    _permissions,
    handleUnauditRecord,
    filters,
    setFilterOperation,
    setFilters,
    showModalExport,
    setShowModalExport,
    downloadGridData,
    isDownloadingFile,
  } = useExceptions(permissions, selectedPractices);
  const theme = getTheme(process.env.REACT_APP_CLIENT_THEME);
  const MODULE_KEY = "TS";

  useEffect(() => {
    // TODO make API call
    setFilterOperation(operations);
  }, []);

  const id = open ? "simple-popover" : undefined;

  return (
    <TemplateWrapped title="Exceptions" headerButtons={<></>} showTitle={false}>
      {practicesSelected.length === 0 && (
        <main className="flex-1 overflow-auto p-6 mt-5">
          <div
            className="alert alert-alt alert-warning"
            role="alert"
            style={{
              padding: "20px 12px",
              fontSize: "14px",
              borderLeft: "3px solid",
            }}
          >
            Dear user, once you select a connection, the corresponding data will
            be displayed
          </div>
          <ConnectionsMainContent />
        </main>
      )}

      {practicesSelected.length > 0 && (
        <div
          className="panel"
          style={{ backgroundColor: "transparent", boxShadow: "none" }}
        >
          <div className="panel-body">
            <main className="flex-1 overflow-auto pt-6 pb-8">
              {/* Page Header */}
              <div className="mb-8">
                <h1 className="text-2xl font-bold text-gray-900 mb-2">
                  Exceptions
                </h1>
                <p className="text-gray-500">
                  Monitor and manage insurance verification exceptions
                </p>
              </div>

              {/* Filters */}
              <FiltersExceptions
                statusSelected={statusSelected}
                practiceSelected={practiceSelected}
                handleClick={handleClick}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                id={id}
                clientSelected={clientSelected}
                practiceSelectedLabel={practiceSelectedLabel}
                changeCurrentDate={changeCurrentDate}
                currentDate={currentDate}
                togglePracticeModal={togglePracticeModal}
                theme={theme}
                filters={filters}
                setFilters={setFilters}
                setShowModalExport={setShowModalExport}
                permissions={permissions}
                moduleKey={MODULE_KEY}
              />

              {/* Data Table */}
              <InsuranceVerificationsTable
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                totalItems={totalItems}
                transactions={transactions}
                handleChangeShowFilesModal={handleChangeShowFilesModal}
                handleVerify={handleVerify}
                handleUnauditRecord={handleUnauditRecord}
                permissions={permissions}
                moduleKey={MODULE_KEY}
              />

              <SelectPracticePopover
                popoverState={popoverState}
                isPracticesOpen={isPracticesOpen}
                handleClose={handleClose}
                practiceSelected={practiceSelected}
                changePracticeSelected={changePracticeSelected}
                practicesListWithName={practicesListWithName}
              />

              <SelectStatusPopover
                popoverState={popoverState}
                isStatusOpen={isStatusOpen}
                handleClose={handleClose}
                changeStatusSelected={changeStatusSelected}
                statusSelected={statusSelected}
              />
              {showFileModal && (
                <CustomModal
                  size="xl"
                  title="Files"
                  onHide={() => {
                    setShowFileModal(false);
                    setFiles(null);
                  }}
                  show={setShowFileModal}
                >
                  <FilesList
                    id={files}
                    practice={"practiceId"}
                    canDownloadFiles={
                      _permissions.files?.downloadFiles || false
                    }
                  />
                </CustomModal>
              )}
            </main>
          </div>
        </div>
      )}

      <CustomModal
        show={showModalExport}
        onHide={() => setShowModalExport(false)}
        title="Confirmation"
        size="md"
        header={false}
      >
        <ConfirmExportExcel
          isDownloadingFile={isDownloadingFile}
          downloadGridData={downloadGridData}
          setShowModalExport={setShowModalExport}
        />
      </CustomModal>
    </TemplateWrapped>
  );
};

export default Exceptions;
